import { Page } from './../../../shared/models/page';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { OnyxEvent } from '../../models/event';
import { Rsvp } from '../../models/rsvp';
import { StaySummary } from '../../models/stay-summary';
import { RsvpStore } from '../../service/rsvp.store';
import { PagesizeType } from '../../service/pagination/pagesize-type';
import { UserLocalStorageService } from '../../../permission/services/user.local.storage.service';
import { Party } from '../../models/party';
import { PaymentSummary } from 'app/event/models/payment-summary/payment-summary';
import { catchError, map, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { ErrorHandlerService } from 'app/shared/utils/error-handler.service';
import { TranslateService } from '@ngx-translate/core';
import { PaymentSummaryStore } from 'app/event/service/payment-summary/payment-summary.store';

@Component({
  selector: 'pioneer-payment-rsvp',
  templateUrl: './payment-rsvp.component.html'
})
export class PaymentRsvpComponent implements OnInit, OnDestroy {

  public onyxEvent: OnyxEvent;

  @Input()
  public vendor: Party;

  public rsvpsPage: Page<Rsvp>;
  public staySummary: StaySummary;

  pagesizeType = PagesizeType.PAYMENT_RSVP;

  @Input('event')
  set event(event: OnyxEvent) {
    this.onyxEvent = event;
  }

  private _destroy$ = new Subject<void>();

  constructor(private rsvpStore: RsvpStore,
              private userLocalStorageService: UserLocalStorageService,
              private paymentSummaryStore: PaymentSummaryStore,
              private errorHandlerService: ErrorHandlerService,
              private translateService: TranslateService) {
  }

  ngOnInit() {
    this.goToRecordsPage(0);

    this.paymentSummaryStore.getPaymentSummary(this.vendor.eventPartyId)
      .pipe(
        takeUntil(this._destroy$),
        catchError(err => {
          this.errorHandlerService.throw(err.message, this.translateService.instant('MESSAGES.ERROR.COULD_NOT_GET_PAYMENT_SUMMARY'));
          return Observable.empty();
        }),
        map((paymentSummary: PaymentSummary) => {
          this.staySummary = new StaySummary({
            totalNights: paymentSummary.roomCommissionSummary.totalNights,
            totalRevenue: paymentSummary.roomCommissionSummary.totalSpend,
            avgRoomRate: paymentSummary.roomCommissionSummary.avgRoomRate,
            totalCommission: paymentSummary.roomCommissionSummary.amountDue
          });
        })
      )
      .subscribe();
  }

  ngOnDestroy(): void {
    this._destroy$.next();
    this._destroy$.complete();
  }

  getCommission(rsvp: Rsvp): number {
    let commission: number;
    if (rsvp) {
      let revenue = rsvp.revenue;
      if (!revenue) {
        revenue = this.getRevenue(rsvp);
      }
      commission = (revenue * this.vendor.commissionRoomPercentage) / 100;
    } else {
      commission = undefined;
    }
    return commission;
  }

  getCommissionFromStaySummary(staySummary: StaySummary): number {
    return staySummary ? staySummary.totalRevenue * this.vendor.commissionRoomPercentage / 100 : undefined;
  }

  goToRecordsPage(pageNumber: number) {
    this.rsvpStore.getRsvpsFromVendor(this.onyxEvent.eventId, this.vendor.eventPartyId, pageNumber,
      this.userLocalStorageService.getPagesize(PagesizeType.PAYMENT_RSVP))
      .map(page => this.rsvpsPage = page )
      .take(1)
      .subscribe();
  }

  private getRevenue(rsvp: Rsvp): number {
    return rsvp ? rsvp.nights * rsvp.roomRate : undefined;
  }

}



// WEBPACK FOOTER //
// /home/gitlab-runner/builds/qfGQY7pgg/1/oneonyx/grouppay-group/grouppay/pioneer-web/src/app/event/payment/rsvp/payment-rsvp.component.ts